<template>
  <div>
    <v-container>
      <v-row align="center" justify="center">
        <v-col cols="12" align="center">
          <v-card>
            <!-- <pre>{{pr}}</pre> -->
            <v-card-text class="test_carousel">
              <v-row class="mb-4" align="center" justify="center">
                <h1 class="primary--text pb-6 mt-6">ประชาสัมพันธ์</h1>
                <v-btn
                  class="float-right ml-5 mt-0"
                  align="center"
                  justify="center"
                  color="#636262"
                  text
                  fab
                  @click="openSetting()"
                  v-if="mode"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </v-row>
              <v-carousel>
                <v-carousel-item
                  v-for="(item, i) in pr"
                  :key="i"
                  @click="$router.push('/prdetail?id=' + item.information_id)"
                  transition="fade-transition"
                >
                  <v-img
                    v-if="item.information_file_type != 'video/mp4'"
                    class="image-fluid"
                    contain
                    :src="env + '/' + item.information_file_path"
                  ></v-img>
                  <!-- <pre>{{item}}</pre> -->
                  <div class="text-center float-center">
                    <!-- <v-img
                      style="
                        background-repeat: no-repeat;
                        background-size: contain;
                      "
                      :src="env + '/' + item.information_file_path"
                    ></v-img> -->
                    <!-- <img
                      max-width="1150px"
                      max-height="500px"
                      :src="env + '/' + item.information_file_path"
                      alt="รูปภาพประชาสัมพันธ์"
                    /> -->
                  </div>

                  <iframe
                    v-if="item.information_file_type == 'video/mp4'"
                    width="1150px"
                    height="450px"
                    :src="env + '/' + item.information_file_path"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </v-carousel-item>
              </v-carousel>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <DialogPR ref="dialog_pr_setting" @getpr="getInformation()"></DialogPR>
  </div>
</template>
<script>
import DialogPR from "../Settings/DialogPR";
export default {
  components: {
    DialogPR,
  },
  data() {
    return {
      mode: false,
      env: process.env.VUE_APP_API,
      pr: [],
      length: 2,
      window: 0,
      showArrows: false,
      autorun: true,
    };
  },
  created() {
    this.getInformation(),
      setInterval(() => {
        if (!this.autorun) return;
        if (++this.window >= this.length) this.window = 0;
      }, 1000);
    this.mode = this.$session.get("token")
      ? this.$session.get("permission") == "admin"
      : false;
  },
  methods: {
    getInformation() {
      let information = [];
      let information_detail = {};
      let all_information = [];
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/information/all")
        .then((response) => {
          // console.log(response.data);

          information = response.data;
          // information.forEach((element) => {
          //   this.axios
          //     .get(
          //       process.env.VUE_APP_API +
          //         "/api/v1/information_join/" +
          //         element.information_id
          //     )
          //     .then((response) => {
          //       // console.log(response.data);
          //       information_detail = response.data;
          //       all_information.push(information_detail);
          //     });
          // });
          this.pr = information;
        });
    },
    openSetting() {
      this.$refs.dialog_pr_setting.openSetting();
    },
  },
};
</script>
<style >
.test_carousel > .v-btn--round .v-btn__content .v-icon {
  color: red;
}

.image-fluid {
  background-size: contain;
  background-position: center;
  width: 100%;
  height: 100%;
}
</style>